import { forwardRef } from 'react';

import styles from './SelectableListItem.module.css';

type SelectableListItemProps = {
  title?: string;
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  selectedKey: string;
  isSelected: boolean;
  number?: number;
  className?: string;
  onClick: () => void;
};

export const SelectableListItem = forwardRef<HTMLDivElement, SelectableListItemProps>(
  ({ isSelected, number, onClick, icon, label, title, className = '' }, ref) => {
    return (
      <div
        ref={ref}
        className={`${styles.listItem} ${isSelected ? styles.selected : ''} ${className}`}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        title={title}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <span className={styles.label}>{label}</span>
        {number != null && <span className={styles.number}>{number}</span>}
      </div>
    );
  }
);

SelectableListItem.displayName = 'SelectableListItem';
